import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import {
  GET_EMAIL_TEMPLATES,
  ADD_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE,
  DELETE_EMAIL_TEMPLATE,
  SET_DEFAULT_EMAIL_TEMPLATE,
  GET_DEFAULT_EMAIL_TEMPLATE
} from "../../helpers/url_helper";

const api = new APIClient();

export const fetchTemplates = createAsyncThunk(
  "emailTemplates/fetchTemplates", 
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_EMAIL_TEMPLATES);
      console.log("Raw API Response:", response);
      
      // Handle different response formats
      let templates = [];
      if (Array.isArray(response)) {
        templates = response;
      } else if (response && Array.isArray(response.data)) {
        templates = response.data;
      } else if (response && response.templates) {
        templates = response.templates;
      }
      
      console.log("Processed templates:", templates);
      return templates;
    } catch (error) {
      console.error("Error fetching email templates:", error);
      return rejectWithValue(error.message || "Failed to fetch templates");
    }
  }
);

export const addTemplate = createAsyncThunk("emailTemplates/addTemplate", async (tpl) => {
  return await api.create(ADD_EMAIL_TEMPLATE, tpl);
});

export const updateTemplate = createAsyncThunk("emailTemplates/updateTemplate", async (tpl) => {
  return await api.put(`${UPDATE_EMAIL_TEMPLATE}/${tpl.id}`, tpl);
});

export const deleteTemplate = createAsyncThunk("emailTemplates/deleteTemplate", async (id) => {
  return await api.delete(`${DELETE_EMAIL_TEMPLATE}/${id}`);
});

export const setDefaultTemplate = createAsyncThunk("emailTemplates/setDefaultTemplate", async (id) => {
  return await api.post(`${SET_DEFAULT_EMAIL_TEMPLATE}/${id}/set-default`);
});
